import { observer, inject } from "mobx-react";
import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  GridColumn,
  GridRow,
  Loader,
  GridContainer,
  Img,
} from "arv-reactcomponents";
import BodyOverlay from "../../BodyOverlay";
import SavedCardBlock from "../../SavedCardBlock";
import { MYACCOUNTPAGE, Endpoints } from "npmlinks-constants";

const { ACCOUNT_SAVED_CARDS } = MYACCOUNTPAGE;

@inject("MyAccountStore")
@observer
class AccountSavedCardsDetails extends Component {
  constructor(props) {
    super(props);
    this.onDeleteCardClick = this.onDeleteCardClick.bind(this);
  }

  onDeleteCardClick(savedCard) {
    const cardReq = {
      cardToken: savedCard.cardToken,
      pgCode: savedCard.pgCode,
    };
    BodyOverlay.component.show();
    this.props.MyAccountStore.deletePaymentCard(cardReq)
      .then(() => {
        this.props.MyAccountStore.savedCardsDetails();
        BodyOverlay.component.hide();
        console.log("Card deleted successfully");
      })
      .catch(() => {
        BodyOverlay.component.hide();
        console.log("API error for deleting card");
      });
  }

  get allSavedCards() {
    return (
      <GridColumn className="">
        {this.props.MyAccountStore.savedCards.map(savedCardsDetail => (
          <SavedCardBlock.component
            cardDetails={savedCardsDetail}
            onDelete={this.onDeleteCardClick}
          />
        ))}
      </GridColumn>
    );
  }

  get noCards() {
    return (
      <GridColumn>
        <div className="nw-accountsavedcard-nocards">
          <Img
            className="nw-accountsavedcard-nocards-smiley"
            src={Endpoints.sadSmileyImage}
            alt="noCards"
          />
          <div className="nw-accountsavedcard-nocards-title">OOPS!</div>
          <div className="">{ACCOUNT_SAVED_CARDS.NO_CARD}</div>
        </div>
      </GridColumn>
    );
  }

  render() {
    const { cardLoader, MyAccountStore } = this.props;
    const { savedCards } = MyAccountStore;
    return (
      <GridContainer className="nw-accountsavedcard-container">
        <GridRow>
          {cardLoader && <Loader className="nw-accountsavedcard-loader" />}
          {!cardLoader &&
            savedCards &&
            savedCards.length > 0 &&
            this.allSavedCards}
          {!cardLoader &&
            (!savedCards || savedCards.length === 0) &&
            this.noCards}
        </GridRow>
      </GridContainer>
    );
  }
}

AccountSavedCardsDetails.wrappedComponent.propTypes = {
  MyAccountStore: PropTypes.shape({
    savedCardsDetails: PropTypes.func.isRequired,
    deletePaymentCard: PropTypes.func.isRequired,
    savedCards: PropTypes.shape({}),
  }).isRequired,
  cardLoader: PropTypes.bool.isRequired,
};

const getFinalComponent = component =>
  inject("MyAccountStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: AccountSavedCardsDetails.wrappedComponent,
  component: AccountSavedCardsDetails,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/MyAccountComponent/AccountSavedCardDetails/index.js